'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var tslib = require('tslib');
var ClearButton = require('../ClearButton/ClearButton.js');
require('../../typography/ErrorText/ErrorText.js');
require('../../typography/LargeDarkText/LargeDarkText.js');
require('../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
var MediumDarkText = require('../../typography/MediumDarkText/MediumDarkText.js');
require('../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../typography/MediumText/MediumText.js');
require('../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../typography/SmallDarkText/SmallDarkText.js');
require('../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../../typography/SmallLinkText/SmallLinkText.js');
require('../../typography/SmallTitleText/SmallTitleText.js');
require('../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../typography/TinyDarkText/TinyDarkText.js');
require('../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../typography/TinyLinkText/TinyLinkText.js');
require('../../typography/TinyTitleText/TinyTitleText.js');
require('../../typography/XXLargeDarkText/XXLargeDarkText.js');
var ProgressBar = require('../../ProgressBar/ProgressBar.js');

var getAttachmentIndex = function (id, attachments) {
    return attachments.findIndex(function (a) { return a.id === id; });
};
var processAttachmentByIndex = function (id, attachments, callback) {
    var index = getAttachmentIndex(id, attachments);
    if (index >= 0) {
        callback(index);
    }
};
var formatBytes = function (bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    // ported from legwork-core-node: client/code/common/components/file-upload-list-item.jsx
    var units = ['B', 'KB', 'MB', 'GB', 'TB'];
    var newBytes = bytes;
    var i;
    for (i = 0; newBytes >= 1024 && i < 4; i += 1) {
        newBytes /= 1024;
    }
    if (i === 0) {
        return "" + bytes + units[i];
    }
    return "" + newBytes.toFixed(decimals) + units[i];
};
var getGenerateRow = function (onRemoveAttachment, fm) {
    return function (row) {
        var attachmentValue = row.data[0];
        var attachment = attachmentValue;
        var progressStyles = {
            color: {
                barColor: '#31CC97',
                labelColor: '#12253F',
            },
        };
        var progressValue = attachment.progress;
        var doneText = fm('completed');
        if (attachment.status === 'error') {
            progressValue = 100;
            doneText = fm('error');
            progressStyles.color.barColor = '#F07B75';
        }
        var handleRemove = function () {
            onRemoveAttachment(attachment);
        };
        return [
            React__default.createElement(MediumDarkText, { key: row.id + "-fileName" }, attachment.file.name),
            React__default.createElement(MediumDarkText, { key: row.id + "-fileSize" }, formatBytes(attachment.file.size)),
            React__default.createElement(ProgressBar, { key: row.id + "-progressBar", value: progressValue, doneText: doneText, styles: progressStyles }),
            React__default.createElement(ClearButton, { key: row.id + "-remove", onClick: handleRemove }),
        ];
    };
};
var createNewAttachmentsState = function (event, attachments) {
    if (!event.target.files || event.target.files.length === 0)
        return { attachments: attachments };
    var existingAttachmentsByName = {};
    attachments.forEach(function (a) {
        existingAttachmentsByName[a.file.name] = a;
    });
    var files = event.target.files;
    var toRemoveAttachments = {};
    if (files && files.length) {
        var newAttachments = [];
        var count = attachments.length + 1;
        for (var i = 0; i < files.length; i += 1) {
            var file = files[i];
            if (file) {
                newAttachments.push({
                    id: file.name + "-" + (count + newAttachments.length),
                    file: file,
                    status: 'notstarted',
                    progress: 0,
                });
                var existingAttachment = existingAttachmentsByName[file.name];
                if (existingAttachment) {
                    toRemoveAttachments[existingAttachment.id] = existingAttachment;
                }
            }
        }
        return {
            attachments: tslib.__spreadArrays(attachments.filter(function (a) { return !toRemoveAttachments[a.id]; }), newAttachments),
            toRemove: Object.values(toRemoveAttachments),
        };
    }
    return { attachments: attachments };
};
var getTableHeaderNames = function (fm) { return [
    fm('filename'),
    fm('size'),
    fm('uploadProgress'),
    '',
]; };
var getIntlFormat = function (intl, prefix) {
    return function (id) { return intl.formatMessage({ id: prefix + "." + id }); };
};
var attachmentsToRows = function (attachments) {
    return attachments.map(function (attachment, index) { return ({
        id: attachment.file.name + "-" + index,
        data: [attachment],
    }); });
};

exports.attachmentsToRows = attachmentsToRows;
exports.createNewAttachmentsState = createNewAttachmentsState;
exports.formatBytes = formatBytes;
exports.getAttachmentIndex = getAttachmentIndex;
exports.getGenerateRow = getGenerateRow;
exports.getIntlFormat = getIntlFormat;
exports.getTableHeaderNames = getTableHeaderNames;
exports.processAttachmentByIndex = processAttachmentByIndex;
